module.exports = __webpack_public_path__ + "img/completed_compressed.763321b7.jpg";